import Axios from 'axios';

const NETSOINS_WS_CODE_DESCRIPTIONS = {
  0: 'Ok',
  1: 'Error',
  2: 'Invalid "key" parameter',
  3: 'Invalid "type" parameter',
  4: 'Resource outside authorized scope',
  5: 'Resource error',
  6: 'Option not enabled',
  7: 'Cannot use "teranga" type on a production environment',
  8: 'Invalid HTTP method',
};

const apiNetsoins = Axios.create({
  baseURL: "",
  headers: {
    'accept': 'application/xml;charset=UTF-8',
    'Content-Type': 'application/json'
  },
});

function throwIfError(response) {
  if (response?.data?.['WS-Code'] === 0) return;

  const error = new Error(NETSOINS_WS_CODE_DESCRIPTIONS[response?.data?.['WS-Code']] || `Unknown NETSOINS error`);
  error.response = response;
  throw error;
}


export async function getJobs(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/CategorieProfessionnelle?type=anisen&key=${param.key}&output=json`);
  throwIfError(response);
  return response?.data.CategorieProfessionnelle;
}

export async function getSecteurs(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/EtablissementSecteur?type=anisen&key=${param.key}&output=json&fields=Uri,Actif,Libelle`);
  throwIfError(response);
  return response.data.EtablissementSecteur;
}

export async function getSousSecteurs(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/EtablissementSousSecteur?type=anisen&key=${param.key}&output=json&fields=Uri,Actif,Libelle`);
  throwIfError(response);
  return response.data.EtablissementSousSecteur;
}


export async function getResidents(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/Resident?type=anisen&key=${param.key}&output=json&fields=Uri,Actif,Genre,Nom,Prenom,DateNaissance,EtablissementChambre`);
  throwIfError(response);
  return response.data.Resident;
}

export async function getPersonnels(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/Personnel?type=anisen&key=${param.key}&output=json&fields=Uri,Actif,Genre,Nom,Prenom,CategorieProfessionnelle`);
  throwIfError(response);
  return response.data.Personnel;
}

export async function getLieux(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/Lieu?type=anisen&key=${param.key}&output=json&fields=Uri,Actif,Libelle,Activite`);
  throwIfError(response);
  return response.data.Lieu;
}

export async function getActivites(param){
  const response = await apiNetsoins.get(`${param.uri}/webservice.php/teranga/AnimationAtelier?type=anisen&type_animation=PROJET_PERSONNALISE&key=${param.key}&output=json&fields=Uri,Libelle`);
  throwIfError(response);
  return response.data.AnimationAtelier;
}

export function linkGetLieux(param){
  return `${param.uri}/webservice.php/teranga/Lieu?type=anisen&key=${param.key}&output=csv&fields=Uri,Actif,Libelle,Activite`;
}
export function linkGetSecteurs(param){
  return `${param.uri}/webservice.php/teranga/EtablissementSecteur?type=anisen&key=${param.key}&output=csv&fields=Uri,Actif,Libelle`;
}
export function linkGetSousSecteurs(param){
  return `${param.uri}/webservice.php/teranga/EtablissementSousSecteur?type=anisen&key=${param.key}&output=csv&fields=Uri,Actif,Libelle`;
}
export function linkGetResidents(param){
  return `${param.uri}/webservice.php/teranga/Resident?type=anisen&key=${param.key}&output=csv&fields=Uri,Actif,Genre,Nom,Prenom,DateNaissance,EtablissementChambre`;
}
export function linkGetPersonnels(param){
  return `${param.uri}/webservice.php/teranga/Personnel?type=anisen&key=${param.key}&output=csv&fields=Uri,Actif,Genre,Nom,Prenom,CategorieProfessionnelle`;
}